import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers
import * as G from '../../helpers';
//////////////////////////////////////////////////

const store = ({ availableDriver }) => availableDriver;

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => itemList,
);

const makeSelectPrevItemListGuids = () => createSelector(
  store,
  ({ activeList, allDrivers, prevItemListGuids }) => G.ifElse(
    R.equals(activeList, 'allDrivers'),
    G.getPropFromObject('prevItemListGuids', allDrivers),
    prevItemListGuids,
  ),
);

const makeSelectPagination = () => createSelector(
  store,
  ({ activeList, allDrivers, pagination }) => G.ifElse(
    R.equals(activeList, 'allDrivers'),
    G.getPropFromObject('pagination', allDrivers),
    pagination,
  ),
);

const makeSelectTotalCount = () => createSelector(
  store,
  ({ activeList, totalCount, allDrivers }) => G.ifElse(
    R.equals(activeList, 'allDrivers'),
    G.getPropFromObject('totalCount', allDrivers),
    totalCount,
  ),
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading, activeList, allDrivers }) => G.ifElse(
    R.equals(activeList, 'allDrivers'),
    G.getPropFromObject('loading', allDrivers),
    loading,
  ),
);

const makeSelectTruckTypes = () => createSelector(
  store,
  ({ truckTypes }) => truckTypes,
);

const makeSelectSearchRadius = () => createSelector(
  store,
  ({ searchRadius }) => searchRadius,
);

const makeSelectLocationValue = () => createSelector(
  store,
  ({ locationValue }) => locationValue,
);

const makeSelectDriverInitials = () => createSelector(
  store,
  ({ driverInitials }) => driverInitials,
);

const makeSelectSearchDate = () => createSelector(
  store,
  ({ searchDate }) => searchDate,
);

const makeSelectSearchLocation = () => createSelector(
  store,
  ({ searchLocation }) => searchLocation,
);

const makeSelectPageVisited = () => createSelector(
  store,
  ({ pageVisited }) => pageVisited,
);

const makeSelectCentralizedDispatch = () => createSelector(
  store,
  ({ centralizedDispatch }) => centralizedDispatch,
);

const makeSelectAvailableDriversPageVisited = () => createSelector(
  store,
  ({ availableDriversPageVisited }) => availableDriversPageVisited,
);

const makeSelectActiveList = () => createSelector(
  store,
  ({ activeList }) => activeList,
);

const makeSelectShowUnassignedLoads = () => createSelector(
  store,
  ({ showUnassignedLoads }) => showUnassignedLoads,
);

const makeSelectUnassignedLoads = () => createSelector(
  store,
  ({ unassignedLoads }) => unassignedLoads,
);

const makeSelectTeamFilterValue = () => createSelector(
  store,
  ({ teamFilterValue }) => teamFilterValue,
);

const makeSelectTableTitleFilters = () => createSelector(
  store,
  ({ activeList, allDrivers, tableTitleFilters }) => G.ifElse(
    R.equals(activeList, 'allDrivers'),
    G.getPropFromObject('tableTitleFilters', allDrivers),
    tableTitleFilters,
  ),
);

const makeSelectTitleSortValues = () => createSelector(
  store,
  ({ activeList, allDrivers, titleSortValues }) => G.ifElse(
    R.equals(activeList, 'allDrivers'),
    G.getPropFromObject('titleSortValues', allDrivers),
    titleSortValues,
  ),
);

// all drivers
const makeSelectAllDriversList = () => createSelector(
  store,
  ({ allDrivers: { itemList } }) => itemList,
);

// common
const selectDriverByGuid = createSelector(
  makeSelectItemList(),
  makeSelectAllDriversList(),
  (_, driverGuid) => driverGuid,
  (list, allList, driverGuid) => R.or(
    R.or(R.prop(driverGuid, list), R.prop(driverGuid, allList)),
    {},
  ),
);

export {
  makeSelectItemList,
  // common
  selectDriverByGuid,
  makeSelectTotalCount,
  makeSelectSearchDate,
  makeSelectTruckTypes,
  makeSelectActiveList,
  makeSelectPagination,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectSearchRadius,
  makeSelectLocationValue,
  makeSelectDriverInitials,
  makeSelectSearchLocation,
  // all drivers
  makeSelectAllDriversList,
  makeSelectUnassignedLoads,
  makeSelectTeamFilterValue,
  makeSelectTitleSortValues,
  makeSelectTableTitleFilters,
  makeSelectPrevItemListGuids,
  makeSelectCentralizedDispatch,
  makeSelectShowUnassignedLoads,
  makeSelectAvailableDriversPageVisited,
};
